module.exports = __webpack_public_path__ + "img/hotel.18c43c9d.png";